export default __webpack_public_path__ + "static/media/cutout-bart.b5d10cba.png";